import { render, staticRenderFns } from "./sales_order_complete.vue?vue&type=template&id=bf6d18bc&scoped=true"
import script from "./sales_order_complete.vue?vue&type=script&lang=js"
export * from "./sales_order_complete.vue?vue&type=script&lang=js"
import style0 from "./sales_order_complete.vue?vue&type=style&index=0&id=bf6d18bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6d18bc",
  null
  
)

export default component.exports